import React from "react"

import { useTranslation } from "react-i18next"

import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { IconButton } from "@mui/material"
import { NotificationUtils } from "@synapse-analytics/synapse-ui"

import styles from "./KonanCopyToClipboard.module.scss"

type Props = {
  text: string
  disabled?: boolean
  rounded?: boolean
}

/* Text box with copy to clipboard option */
export function KonanCopyToClipboard(props: Props): React.ReactElement {
  const { text, disabled, rounded } = props

  const { t } = useTranslation("utility")

  return (
    <IconButton
      size="small"
      color="default"
      className={`${styles.button} ${rounded && styles.rounded}`}
      onClick={(e) => {
        e.stopPropagation()
        navigator.clipboard.writeText(text)
        NotificationUtils.toast(t("KonanCopyToClipboard.success"), { severity: "success" })
      }}
      disabled={disabled}
    >
      <ContentCopyIcon className={styles.icon} />
    </IconButton>
  )
}
